import {Injectable} from '@angular/core';
import { API_ENDPOINT, LOCAL_STORAGE_KEY } from '@core/configs';
import { MstMessageRO } from '@core/models/ro/mst-message.model';
import {ApiService} from './api.service';

@Injectable()
export class MstMessageService {
    constructor(private readonly http: ApiService) {
    }

    _mstMessageList: MstMessageRO[] = [];

    get mstMessageList(): MstMessageRO[] {
        const mstMessageList = JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEY.mstMessage)) || [];
        if (this._mstMessageList.length < mstMessageList.length) {
            this._mstMessageList = mstMessageList;
        }
        return this._mstMessageList;
    }

    set mstMessageList(messageList) {
        if (messageList.length > this._mstMessageList.length) {
            this._mstMessageList = messageList;
        }
    }

    async getMstMessageList() {
        const res = await this.http.get(
            API_ENDPOINT.mstMessage.controller +
            API_ENDPOINT.mstMessage.getAll,
        ).toPromise();
        this.mstMessageList = res.result;
        localStorage.setItem(
            LOCAL_STORAGE_KEY.mstMessage,
            JSON.stringify(res.result),
        );
        return res.result;
    }

    async getMstMessageListBeforeLogin() {
        if (this.mstMessageList.length) {
            return this.mstMessageList;
        } else {
            const res = await this.http.get(
                API_ENDPOINT.mstMessage.controller +
                API_ENDPOINT.mstMessage.getByIds,
            ).toPromise();
            this.mstMessageList = res.result;
            return res.result;
        }
    }

    getMessage(id: number): string {
        const mstMessageList = this.mstMessageList;
        let result = '該当データがありません。';
        if (id) {
            const foundMessage = mstMessageList.find(message => message.id === id);
            if (foundMessage) {
                result = foundMessage.message.indexOf('（改行）') !== -1 ?
                    foundMessage.message.replace(/（改行）/g, '\n') : foundMessage.message;
            }
        }
        return result;
    }
}
